module.exports = __webpack_public_path__ + "static/Icons_CurrentHO_Homeloan_Large-9d11dff8acef83ffc98bb765dfc308d1.png";